export default "__VITE_ASSET__DfsXsT2y__";